import focus from 'dom-focus-lock';

type FocusFn<N extends HTMLElement = HTMLElement> = (node: N) => void;

export const focusOn: FocusFn = (node) => focus.on(node);
export const focusOff: FocusFn = (node) => focus.off(node);
